<template>
  <v-card :loading="loadinCard">
    <v-container>
      <v-row>
        <v-col cols="8" class="pb-0 pl-3">
          <v-card-title>
            <span class="pt-0 pb-3 ml-n4 primary--text">{{
              formEditTitle
            }}</span>
          </v-card-title>
        </v-col>
        <v-col cols="4" align="end" class="pt-2 text-right">
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="to-right" icon @click="closeModal">
                <v-icon v-bind="attrs" v-on="on">{{ closeIcon }}</v-icon>
              </v-btn>
            </template>
            <span>Cerrar</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <v-card-text class="pb-0 px-0 pt-0">
        <v-form
          v-model="isFormValid"
          ref="form"
          form="form"
          id="form"
          @submit.prevent="saveEdit()"
        >
          <v-row>
            <v-col cols="3" class="py-2">
              <v-autocomplete
                v-model="motivosSelected"
                :items="motivosViaje"
                clearable
                item-text="value"
                item-value="id"
                outlined
                return-object
                dense
                :disabled="verViaje"
                :filled="verViaje"
                hide-details="auto"
                :rules="rules.required"
                label="Motivos de viaje"
              ></v-autocomplete>
            </v-col>
            <v-col cols="3" class="py-2">
              <v-autocomplete
                v-model="clientesSelected"
                :items="clientes"
                clearable
                item-text="value"
                item-value="id"
                outlined
                return-object
                :disabled="verViaje"
                :filled="verViaje"
                dense
                :rules="rules.required"
                hide-details="auto"
                label="Cliente"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="3" class="pt-2 pb-0">
              <v-autocomplete
                v-model="mediosTransporteSelected"
                :items="mediosTransporte"
                clearable
                item-text="value"
                item-value="id"
                :disabled="verViaje"
                :filled="verViaje"
                outlined
                return-object
                dense
                :rules="rules.required"
                hide-details="auto"
                label="Medios de transporte"
              ></v-autocomplete>
            </v-col>
            <v-col cols="3" class="pt-2 pb-0">
              <v-text-field
                v-model="costo"
                label="Costo"
                type="number"
                :disabled="verViaje"
                :filled="verViaje"
                @keypress="validateNumberInput"
                outlined
                :rules="
                  costo == 0 || costo == null
                    ? []
                    : [].concat(
                        (v) => rules.positiveNumber[0](v),
                        rules.decimal,
                        rules.maxLength(costo, 16)
                      )
                "
                dense
                hide-details="auto"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" class="pt-2 pb-4">
              <v-menu
                ref="fechaDesde"
                v-model="menuFechaDesde"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="fechaDesdeSelected"
                    label="Fecha desde"
                    :append-icon="calendarIcon"
                    :disabled="verViaje"
                    :filled="verViaje"
                    onkeypress="return (event.charCode >= 47 && event.charCode <= 57)"
                    hint="Formato DD/MM/AAAA"
                    hide-details="auto"
                    v-mask="'##/##/####'"
                    @blur="fechaDesde = parseDateToIso(fechaDesdeSelected)"
                    :rules="
                      rules.required.concat(
                        rules.validDate,
                        rules.validDateRange(fechaDesde, fechaHasta)
                      )
                    "
                    dense
                    outlined
                    autocomplete="off"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fechaDesde"
                  @change="fechaDesdeSelected = formatDate(fechaDesde)"
                  no-title
                  scrollable
                  @input="menuFechaDesde = false"
                >
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="3" class="pt-2 pb-4" align="center">
              <v-menu
                ref="menuHoraDesde"
                v-model="menuHoraDesde"
                :close-on-content-click="false"
                :return-value.sync="selectedTimeDesde"
                transition="scale-transition"
                offset-y
                :nudge-bottom="0"
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="selectedTimeDesde"
                    label="Hora desde"
                    append-icon="mdi-clock"
                    outlined
                    :disabled="verViaje"
                    :filled="verViaje"
                    hide-details="auto"
                    dense
                    readonly
                    hint="Formato HH:MM"
                    @focus="menuHoraDesde = true"
                    @input="menuHoraDesde = false"
                    @blur="$refs.menuHoraDesde.save(selectedTimeDesde)"
                    :rules="rules.required"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  scrollable
                  no-title
                  v-if="menuHoraDesde"
                  :allowed-minutes="[0, 15, 30, 45]"
                  v-model="selectedTimeDesde"
                  class="mt-4"
                  format="24hr"
                  @click:minute="$refs.menuHoraDesde.save(selectedTimeDesde)"
                ></v-time-picker>
              </v-menu>
            </v-col>
            <v-col cols="3" class="pt-2 pb-4">
              <v-menu
                ref="fechaHasta"
                v-model="menuFechaHasta"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="fechaHastaSelected"
                    label="Fecha hasta"
                    :append-icon="calendarIcon"
                    :disabled="verViaje"
                    :filled="verViaje"
                    onkeypress="return (event.charCode >= 47 && event.charCode <= 57)"
                    hint="Formato DD/MM/AAAA"
                    hide-details="auto"
                    v-mask="'##/##/####'"
                    @blur="fechaHasta = parseDateToIso(fechaHastaSelected)"
                    :rules="
                      rules.required.concat(
                        rules.validDate,
                        rules.validDateRange(fechaDesde, fechaHasta)
                      )
                    "
                    dense
                    outlined
                    autocomplete="off"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fechaHasta"
                  @change="fechaHastaSelected = formatDate(fechaHasta)"
                  no-title
                  scrollable
                  @input="menuFechaHasta = false"
                >
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="3" class="pt-2 pb-4">
              <v-menu
                ref="menuHoraHasta"
                v-model="menuHoraHasta"
                :close-on-content-click="false"
                :return-value.sync="selectedTimeHasta"
                transition="scale-transition"
                offset-y
                :nudge-bottom="0"
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="selectedTimeHasta"
                    label="Hora hasta"
                    append-icon="mdi-clock"
                    :disabled="verViaje"
                    :filled="verViaje"
                    outlined
                    dense
                    readonly
                    hide-details="auto"
                    hint="Formato HH:MM"
                    @focus="menuHoraHasta = true"
                    @input="menuHoraHasta = false"
                    @blur="$refs.menuHoraHasta.save(selectedTimeHasta)"
                    :rules="rules.required"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  scrollable
                  no-title
                  v-if="menuHoraHasta"
                  :allowed-minutes="[0, 15, 30, 45]"
                  v-model="selectedTimeHasta"
                  class="mt-4"
                  format="24hr"
                  @click:minute="$refs.menuHoraHasta.save(selectedTimeHasta)"
                ></v-time-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="pb-2 pt-0">
              <v-textarea
                v-model="observaciones"
                label="Observación"
                dense
                auto-grow
                :disabled="verViaje"
                :filled="verViaje"
                hide-details="auto"
                rows="1"
                outlined
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="py-2">
              <v-autocomplete
                ref="usuarios-autocomplete"
                v-model.trim="usuarioSelected"
                :items="usuarios"
                :search-input.sync="usuariosAutocompleteInput"
                item-text="value"
                item-value="id"
                @change="usuarioChange(usuarioSelected)"
                :filter="customFilterUsuarios"
                outlined
                clearable
                return-object
                :filled="verViaje"
                :disabled="verViaje"
                dense
                autocomplete="off"
                label="Buscar usuario"
              >
                <template slot="item" slot-scope="{ item }">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.value }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <template v-slot:append>
                  <v-progress-circular
                    indeterminate
                    size="28"
                    v-if="usuariosLoading"
                    color="primary"
                  ></v-progress-circular>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row class="mt-n7">
            <v-col cols="12" md="12" class="py-5">
              <v-data-table
                class="elevation-2"
                :headers="usuariosHeaders"
                :items="usuariosItems"
                :loading="loading"
                :search="search"
                dense
                item-key="id"
                :hide-default-footer="usuariosItems.length > 10 ? false : true"
              >
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-row>
                      <v-col cols="3" align="start">
                        <h4 class="primary--text">Usuarios</h4>
                      </v-col>
                      <v-col cols="6" align-self="center">
                        <v-text-field
                          v-model="search"
                          clearable
                          label="Buscar"
                          single-line
                          :append-icon="iconoSearch"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-toolbar>
                </template>
                <template v-if="!verViaje" v-slot:[`item.actions`]="{ item }">
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        size="20"
                        v-on="on"
                        @click="deleteUsuario(item)"
                      >
                        {{ deleteIcon }}
                      </v-icon>
                    </template>
                    <span>Eliminar usuario</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions class="pr-0">
        <v-spacer></v-spacer>
        <v-btn
          type="submit"
          :disabled="!isFormValid || verViaje || usuariosSelected?.length == 0"
          :loading="loadingSaveBtn"
          form="form"
          color="primary"
        >
          Guardar
        </v-btn>
      </v-card-actions>
    </v-container>
  </v-card>
</template>
  <script>
import rules from "@/utils/helpers/rules";
import enums from "@/utils/enums/index.js";
import { mapActions } from "vuex";

export default {
  name: "EditViajes",
  props: {
    viajesObject: {
      Type: Object,
      required: false,
    },
    verViaje: {
      Type: Boolean,
      default: false,
    },
  },
  data: () => ({
    formEditTitle: "Nuevo viaje",
    fechaDesde: null,
    fechaDesdeSelected: null,
    menuFechaDesde: null,
    fechaHasta: null,
    fechaHastaSelected: null,
    menuFechaHasta: null,
    closeIcon: enums.icons.CLOSE,
    deleteIcon: enums.icons.DELETE,
    calendarIcon: enums.icons.CALENDAR_ICON,
    rules: rules,
    isFormValid: false,
    selectedTimeDesde: null,
    menuHoraDesde: false,
    menuHoraHasta: false,
    selectedTimeHasta: null,
    clientes: [],
    loadinCard: false,
    usuarioSelected: null,
    clientesSelected: null,
    motivosViaje: [],
    motivosSelected: null,
    mediosTransporte: [],
    usuariosItems: [],
    usuariosHeaders: [
      {
        text: "Nombre",
        value: "value",
        align: "start",
        sortable: false,
      },
      {
        text: "Acciones",
        value: "actions",
        sortable: false,
        align: "end",
      },
    ],
    mediosTransporteSelected: null,
    costo: 0,
    observaciones: "",
    usuarios: [],
    usuariosSelected: null,
    loadingSaveBtn: false,
    usuariosAutocompleteInput: null,
    usuariosLoading: false,
    loading: false,
    search: "",
    iconoSearch: enums.icons.SEARCH_ICON,
  }),
  watch: {
    usuariosAutocompleteInput(val) {
      if (val && val.length >= 3) {
        this.getUsuariosFilter();
      }
    },
  },
  async created() {
    await this.setSelects();
    if (this.viajesObject) this.setViaje();
  },
  methods: {
    ...mapActions({
      postViajes: "clientesData/postViajes",
      getMotivosViaje: "clientesData/motivosViajeTaxonomy",
      getClientes: "clientesData/clientesTaxonomy",
      getMediosTransporte: "clientesData/mediosTransporteTaxonomy",
      getAllUsuarios: "presentaciones/getAllUsuarios",
      getUsuariosByQuery: "presentaciones/getUsuariosByQuery",
      setAlert: "user/setAlert",
    }),
    async setSelects() {
      const motivos = await this.getMotivosViaje();
      this.motivosViaje = motivos;
      const mediosTransporte = await this.getMediosTransporte();
      this.mediosTransporte = mediosTransporte;
      const clientes = await this.getClientes();
      this.clientes = clientes;
    },
    customFilterUsuarios(item, queryText) {
      return item.id || item.value.indexOf(queryText) > -1;
    },
    validateNumberInput(event) {
      const char = String.fromCharCode(event.which);
      const allowed = /^[0-9.]$/;
      if (!allowed.test(char)) {
        event.preventDefault();
      }
    },
    async setViaje() {
      this.loadinCard = true;
      this.formEditTitle = "Editar viaje";
      this.motivosSelected = this.motivosViaje.find(
        (x) => x.id == this.viajesObject.mvId
      );
      this.observaciones = this.viajesObject.observaciones;
      this.clientesSelected = this.clientes.find(
        (x) => x.id == this.viajesObject.clienteId
      );
      this.costo = this.viajesObject.costoViaje;
      this.fechaDesdeSelected = this.viajesObject.fechaDesdeStr;
      this.fechaHastaSelected = this.viajesObject.fechaHastaStr;
      this.fechaDesde = this.parseDateToIso(this.fechaDesdeSelected);
      this.fechaHasta = this.parseDateToIso(this.fechaHastaSelected);
      this.selectedTimeDesde = this.formatTimeForPicker(
        this.viajesObject.horaDesde
      );
      this.selectedTimeHasta = this.formatTimeForPicker(
        this.viajesObject.horaHasta
      );

      this.usuariosItems = this.viajesObject.usuariosTaxonomy;
      this.mediosTransporteSelected = this.mediosTransporte.find(
        (x) => x.id == this.viajesObject.mtId
      );
      this.loadinCard = false;
    },
    usuarioChange(data) {
      if (!data) return;
      if (this.usuariosItems.length > 0) {
        const resp = this.usuariosItems.some((x) => x.id == data.id);
        if (resp) {
          this.setAlert({
            type: "error",
            message: "Ya existe un usuario con el mismo nombre.",
          });
        } else {
          this.usuariosItems.push(data);
          this.sortUsuariosTable(this.usuariosItems);
        }
      } else {
        this.usuariosItems.push(data);
        this.sortUsuariosTable(this.usuariosItems);
      }
    },
    getUsuariosFilter() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(async () => {
        if (
          this.usuarios?.some((x) => x.value == this.usuariosAutocompleteInput)
        ) {
          return;
        } else {
          this.usuariosLoading = true;
          const response = await this.getUsuariosByQuery({
            input: this.usuariosAutocompleteInput,
          });
          this.$refs["usuarios-autocomplete"].cachedItems = [];
          this.usuarios = response;
          this.usuariosLoading = false;
        }
      }, 1000);
    },
    sortUsuariosTable(items) {
      items.sort((a, b) => {
        const nombreA = (a.value || "").toLowerCase();
        const nombreB = (b.value || "").toLowerCase();
        if (nombreA < nombreB) return -1;
        if (nombreA > nombreB) return 1;
        return 0;
      });
    },
    deleteUsuario(item) {
      const index = this.usuariosItems.findIndex((u) => u.id === item.id);
      if (index !== -1) {
        this.usuariosItems.splice(index, 1);
      }
      this.setAlert({ type: "success", message: "Usuario eliminado." });
    },
    async saveEdit() {
      this.loadingSaveBtn = true;
      const fechaDesde = this.parseDateToIso(this.fechaDesdeSelected);
      const fechaHasta = this.parseDateToIso(this.fechaHastaSelected);
      const data = {
        viajeId: this.viajesObject?.viajeId ?? -1,
        fechaDesde,
        fechaHasta,
        horaDesdeToShow: this.formatTimeForSave(this.selectedTimeDesde),
        horaHastaToShow: this.formatTimeForSave(this.selectedTimeHasta),
        clienteId: this.clientesSelected?.id,
        mtId: this.mediosTransporteSelected?.id,
        mvId: this.motivosSelected?.id,
        costoViaje: this.costo,
        usuariosIds: this.usuariosItems.map((x) => x.id),
        observaciones: this.observaciones,
      };
      try {
        const response = await this.postViajes(data);
        if (response.status === 200) {
          this.loadingSaveBtn = false;
          this.closeModal();
          this.setAlert({ type: "success", message: "Guardado con éxito." });
          this.loadingSaveBtn = false;
        }
      } catch {
        this.loadingSaveBtn = false;
      }
    },
    usersToggle() {
      this.$nextTick(() => {
        if (this.selectAllUsers) this.usuariosSelected = [];
        else this.usuariosSelected = this.usuarios.map((x) => x.id);
      });
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return;
      const [day, month, year] = date.split("/");
      return `${month}/${day}/${year}`;
    },
    parseDateToIso(date) {
      if (!date) return null;
      if (date.length !== 10) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    formatTimeForPicker(time) {
      if (!time) return null;
      const parts = time.toString().split(":");
      if (parts.length >= 2) {
        return `${parts[0].padStart(2, "0")}:${parts[1].padStart(2, "0")}`;
      }
      return parts[0].padStart(2, "0");
    },
    formatTimeForSave(time) {
      if (!time) return null;
      return time.length === 5 ? `${time}:00` : time;
    },
    closeModal() {
      this.$emit("closeAndReload");
    },
  },
};
</script>
  
 <style>
.v-input.v-input--is-disabled .v-input__control .v-input__slot input {
  color: #000 !important;
}
/* Estilo común para todos los inputs deshabilitados */
/* .v-input.v-input--is-disabled .v-input__control .v-input__slot input,
.v-input.v-input--is-disabled .v-input__control .v-input__slot textarea,
.v-input.v-input--is-disabled
  .v-input__control
  .v-input__slot
  .v-select__selection--comma {
  color: #000 !important;
} */
</style>

  